import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

// TYPES
import {
  QuoteRequest,
  QuoteResponse,
  TypeExchangeRequest,
} from '@/types/QuoteType';
import { RouteTransfer } from '@/types/RouteTransferType';

import {
  Transaction,
  InboundBank,
  IConfirmationTransaction,
} from '@/types/TransactionType';
import PaymentType from '@/types/PaymentTypes';
import { PaymentObject } from '@/types/PaymentObject';
import { PayInResponse } from '@/types/PayInResponse';
import { InvoiceVoucher } from '@/types/InvoiceVoucher';
import { DirectDeposit } from '@/types/DirectDepositType';
import { IServiceP2pParams } from '@/types/services/ICreateP2pPayload';
import { AxiosProgressEvent } from 'axios';

export const transactionClient = {
  getRoutes() {
    return ApiAxiosInstance.get<RouteTransfer[]>('route/b2b/routes');
  },

  getExternalRoutes() {
    return ApiAxiosInstance.get<RouteTransfer[]>('route/ext/routes');
  },

  /**
   * @deprecated Usar cashInService.getCustomerPaymentMethod() de @/modules/cashIn
   */
  getCustomerPaymentMethod(routeId: number, originAmountUSD: number) {
    return ApiAxiosInstance.get<PaymentType[]>(
      `route/b2b/payment-methods?routeId=${routeId}&customerTypeB2B=true&originAmountUSD=${originAmountUSD}`
    );
  },

  postExchange(exchangeRequest: TypeExchangeRequest) {
    return ApiAxiosInstance.post<QuoteResponse>(
      'quote/b2b/exchange',
      exchangeRequest
    );
  },

  savePurposeDocuments(
    transactionId: string,
    files: FormData,
    onUploadProgress: any
  ) {
    return ApiAxiosInstance.put(
      `transaction/b2b/upload/purpose/${transactionId}`,
      files,
      {
        onUploadProgress,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
  /**
   * @deprecated Usar transactionService.createQuote() del módulo @/shared/common
   */
  sendQuote(quoteRequest: QuoteRequest) {
    return ApiAxiosInstance.post<QuoteResponse>(`quote/b2b`, quoteRequest);
  },

  sendTransaction(transactionData: Transaction) {
    return ApiAxiosInstance.post<Transaction>(
      'transaction/b2b/wire-transfers',
      transactionData
    );
  },

  /**
   * @deprecated Usar transactionService.cancelTransaction() de @/shared/common/services/transaction.service
   */
  cancelTransaction(id: number) {
    return ApiAxiosInstance.delete<Transaction>('transaction/customer', {
      params: { id },
    });
  },

  /**
   * @deprecated Usar transactionService.getTransactionWithSla() de @/shared/common/services/transaction.service
   */
  getTransaction(transactionId: string | undefined, calculateSla = false) {
    return ApiAxiosInstance.get<Transaction>(
      `transaction/customer/${transactionId}`,
      {
        params: {
          calculateSla,
        },
      }
    );
  },


  /**
   * @deprecated Usar cashInService.createPartnerCashIn() de @/modules/cashIn
   */
  makePartnerCashIn(paymentObject: PaymentObject) {
    return ApiAxiosInstance.post<PayInResponse>(
      'payment/b2b/pay-in',
      paymentObject,
      {
        headers: {
          'X-API-VERSION': '2',
        },
      }
    );
  },

  /**
   * @deprecated Usar cashInService.createGatewayPayment() de @/modules/cashIn
   */
  makeGatewayPartnerCashIn(paymentObject: PaymentObject) {
    return ApiAxiosInstance.post<PayInResponse>(
      'product-gateway/b2b/payments/pay-in',
      paymentObject
    );
  },

  makePayment({
    authValue,
    authType,
    transactionId,
    countryCode,
  }: IConfirmationTransaction) {
    return ApiAxiosInstance.post<Transaction>(
      'transaction/b2b/confirm-transaction-in-product',
      {
        transactionId,
        countryCode,
      },
      {
        headers: {
          authType,
          authValue,
        },
      }
    );
  },

  createP2P(data: IServiceP2pParams) {
    return ApiAxiosInstance.post(
      `product-gateway/b2b/p2p/payment/${data.originWalletId}`,
      data.payload,
      {
        headers: {
          authType: data?.authType,
          authValue: data?.authValue,
        },
      }
    );
  },

  /**
   * @deprecated Usar transactionService.downloadInvoice() de @/shared/common/services/transaction.service
   */
  downloadInvoicePdf(data: InvoiceVoucher) {
    return ApiAxiosInstance.post<BlobPart>(
      'transaction/b2b/voucher-pdf',
      data,
      {
        responseType: 'blob',
      }
    );
  },

  /**
   * @deprecated Usar transactionService.createDeposit() de @/modules/cashIn
   */
  makeDeposit(transactionId: string | undefined, bankData: InboundBank) {
    return ApiAxiosInstance.put<DirectDeposit>(
      `transaction/b2b/deposits/${transactionId}`,
      bankData
    );
  },

  /**
   * @deprecated Usar transactionService.transactionVoucher() de @/modules/transaction/services/transaction.service
   */
  transactionVoucher(
    payload: FormData,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ) {
    return ApiAxiosInstance.post<string[]>(
      `transaction/b2b/vouchers`,
      payload,
      {
        onUploadProgress,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },
};
